<template>
  <div class="q-table-container no-shadow q-table-dense">
    <div class="q-table-middle scroll">
      <table class="q-table q-table-horizontal-separator no-shadow">
        <thead>
          <tr>
            <th class="text-left" style="width: 80px;"></th>
            <th
              v-for="column in validColumns"
              :key="column.field"
              v-text="column.label"
              class="text-left"
            ></th>
            <th v-if="showEdit" class="text-center" style="width: 80px;"></th>
            <th v-if="showDelete" class="text-center" style="width: 80px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="row.id">
            <td class="text-left" style="width: 80px">
              <q-icon
                :class="{'invisible': selectedRowIds.indexOf(row.id) === -1}"
                name="check circle"
                color="positive"
              ></q-icon>
            </td>
            <td
              v-for="column in validColumns"
              :key="`row-${row.id}-${column.field}`"
              class="text-left cursor-pointer"
              @click="handleSelect(index)"
            >
              <span v-if="column.field === 'imageUrl'">
                <img class="flex inline flex-center" :src="row | relationLabel(column, parentColumnMap[column.field])" style="max-height:36px; width: auto;" />
<!--                <a v-if="value && typeof value === 'string' && value.startsWith('http')" :href="value" target="_blank"><img class="flex inline shadow-box flex-center shadow-6" :src="value" style="max-height:36px; width: auto;" /></a>-->
              </span>
              <span v-else>{{ row | relationLabel(column, parentColumnMap[column.field]) }}</span>
            </td>
            <td class="text-center" style="width: 80px;">
              <q-btn
                v-if="showEdit"
                icon="edit"
                color="positive"
                flat
                round
                @click="handleEdit(index)"
              ></q-btn>
            </td>
            <td class="text-center" style="width: 80px;">
              <q-btn
                v-if="showDelete"
                icon="delete"
                color="negative"
                flat
                round
                @click="handleDelete(index)"
              ></q-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailsTable',

  props: {
    columns: {
      type: Array,
      required: true,
      default: () => []
    },
    parentColumnMap: {
      type: Object
    },
    rows: {
      type: Array,
      required: true,
      default: () => []
    },
    selected: {
      type: [Object, Array]
    },
    showDelete: {
      type: Boolean,
      default: true
    },
    showEdit: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    selectedList () {
      if (this.selected) {
        return Array.isArray(this.selected) ? this.selected : [this.selected]
      }
      return []
    },
    selectedRowIds () {
      return this.selectedList.filter(row => !!row.id).map(row => parseInt(row.id))
    },
    validColumns () {
      return this.columns && this.columns.length ? this.columns.filter(c => c && typeof c === 'object') : []
    }
  },

  methods: {
    handleSelect (index) {
      // console.log('handleSelect', index, this.rows[index])
      this.$emit('select', { index, model: this.rows[index] })
    },
    handleDelete (index) {
      // console.log('handleDelete', index, this.rows[index])
      this.$emit('remove', { index, model: this.rows[index] })
    },
    handleEdit (index) {
      // console.log('handleEdit', index, this.rows[index])
      this.$emit('edit', { index, model: this.rows[index] })
    }
  }
}
</script>
